import { gql } from "@/__generated__/gql";

export const USER_ACTION_METRICS = gql(`
  query UserActionMetrics(
    $actionId: ID!
    ) {
    node(id: $actionId) {
      ... on RiseUserAction {
      id
      metrics {
        doneCount
        notDoneCount
        skippedCount
      }
    }
  }
}
`);
